import { ReactNode } from 'react';
import { Box, Grid, Typography, useTheme, useMediaQuery, Stack, Divider } from '@mui/material';

// Project Imports
import AuthFooter from 'components/cards/AuthFooter';
import VidyalayaLogo from 'assets/images/vid_lms_logo.png';
import AuthCard from './AuthCard';
import AuthBackground from 'assets/images/auth/AuthBackground';

interface Props {
  children: ReactNode;
  organizationLogo?: { path?: string };
  sx?: object;
}

const AuthWrapper = ({ children, organizationLogo, sx }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh', // Ensure the Box takes up the full viewport height
        overflowX: 'hidden',
        position: 'relative',
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
          overflow: 'hidden',
        }}
      >
        <AuthBackground />
      </Box>

      <Grid
        container
        xs={12}
        md={10}
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          alignItems: window.location.pathname === '/register/student' ?'start' : 'center',
          justifyContent: window.location.pathname === '/register/student' ? 'start' : 'center',
          minHeight: '100vh',
          mx: 'auto'
        }}
      >
        {/* Left - Logo & Message */}
        <Grid
          item
          xs={12}
          md={5} // Decreased from md={6} to md={5}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 3,
            py: 4,
            order: { xs: 1, md: 0 },
            marginTop:  window.location.pathname === '/register/student' ? '150px':'0px',
            
          }}
        >
          <Box sx={{ mb: 3, width: '100%' }}>
            <Stack
              direction={'row'}
              alignItems="center"
              justifyContent="center"
              spacing={isMobile ? 1 : 1.5}
            >
              {organizationLogo?.path && (
                <>
                  <img
                    src={process.env.REACT_APP_FILE_URL + organizationLogo?.path}
                    alt="Organization Logo"
                    style={{
                      width: isMobile ? 80 : 150,
                      height: 'auto',
                    }}
                  />
                  <Divider
                    orientation={'vertical'}
                    flexItem
                    sx={{ mx: isMobile ? 0 : 1.5, my: isMobile ? 1 : 0 }}
                  />
                </>
              )}
              <img
                src={VidyalayaLogo}
                alt="Vidyalaya Logo"
                style={{
                  width: isMobile ? 90 : 150,
                  height: 'auto',
                }}
              />
            </Stack>
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              maxWidth: 400, // Slightly reduced from 450px to fit the narrower grid
              px: 2,
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.75rem' },
              lineHeight: 1.5,
            }}
          >
            Bridge Knowledge Gaps Faster with Result-driven Learning Management System!
          </Typography>
        </Grid>

        {/* Right - Auth Card */}
        <Grid
          item
          xs={12}
          md={7} // Increased from md={6} to md={7}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            px: 3,
            py: 4,
            order: { xs: 2, md: 1 },
          }}
        >
          <Box sx={{ width: '100%', maxWidth: 900 }}> {/* Increased from 450px to 900px to match StudentAuthRegister */}
            <AuthCard>{children}</AuthCard>
            <Box sx={{ mt: 2 }}>
              <AuthFooter />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthWrapper;